export default function OrderDetail() {
  return (
    <div>OrderDetail</div>
  )
}
